import { Skeleton, Stack } from '@chakra-ui/react';

const ITEMS_GAP = 16;
const ITEM_HEIGHT = 22.84;

interface ListingFiltersSkeletonDesktopCheckboxGroupProps {
    withShowMore?: boolean;
    itemsCount: number;
}

export const ListingFiltersSkeletonDesktopCheckboxGroup = ({
    withShowMore,
    itemsCount,
}: ListingFiltersSkeletonDesktopCheckboxGroupProps) => (
    <Stack gap={4}>
        <Skeleton width="160px" height="24px" />
        <Skeleton height={`${itemsCount * (ITEM_HEIGHT + ITEMS_GAP) - ITEMS_GAP}px`} />
        {withShowMore && <Skeleton width="94px" height="25px" />}
    </Stack>
);
